export const NEED_SELECTION_ITEMS = ['input', 'number', 'refer', 'residtxt'];
